// extracted by mini-css-extract-plugin
export default {"modalOverlay":"yJ-z","modalContent":"zJ-z","header":"AJ-z","close":"BJ-z"};